import { toPrintFormat } from '../../utils/date-utils'
import { Employee } from '../../api-clients/api-types'

const draftUpdateDate = (draftEmployee?: Employee) => {
  const dateUpdated =
    draftEmployee && draftEmployee?.lastUpdate !== null && toPrintFormat(draftEmployee.lastUpdate)
  const dateCreated = draftEmployee && draftEmployee?.createdAt !== null && toPrintFormat(draftEmployee.createdAt)
  const updatedBy = draftEmployee?.sourceLastUpdate && `(${draftEmployee.sourceLastUpdate})`
  const createdBy = draftEmployee?.createdBy && `(${draftEmployee.createdBy})`

  const anyDates = dateUpdated || dateCreated

  return (
    anyDates && (
      <div id="updated-date">
        Utkast oppdatert: {dateUpdated || dateCreated} {updatedBy || createdBy}
      </div>
    )
  )
}

export default draftUpdateDate
